import { render, staticRenderFns } from "./Featurette.vue?vue&type=template&id=8b0ec0c2"
import script from "./Featurette.vue?vue&type=script&lang=js"
export * from "./Featurette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports